import React, {PropsWithChildren} from 'react';
import {View, Text, TouchableOpacity} from 'react-native';

import {text} from '../../text';
import {svg} from '../../assets/svg';
import {theme} from '../../constants';
import {PromocodeType} from '../../types';

type Props = PropsWithChildren<{
  item: PromocodeType;
  isLast?: boolean;
}>;

const PromocodeItem: React.FC<Props> = ({item, isLast}): JSX.Element => {
  const resolveBadgeColor = (discount: number) => {
    if (discount <= 0) {
      return theme.colors.textMuted;
    }

    if (discount < 35) {
      return '#FFA462';
    }

    if (discount <= 50) {
      return '#FA5555';
    }

    return theme.colors.accentPrimary;
  };

  const formatDiscountLabel = (discount: number) => {
    if (!Number.isFinite(discount) || discount <= 0) {
      return 'Special offer';
    }

    if (discount > 0 && discount <= 1) {
      return `${Math.round(discount * 100)}% discount`;
    }

    if (discount > 100) {
      return `$${discount.toFixed(2)} discount`;
    }

    return `${Math.round(discount)}% discount`;
  };

  return (
    <TouchableOpacity
      style={{
        backgroundColor: theme.colors.backgroundPrimary,
        borderRadius: 10,
        padding: 20,
        marginBottom: isLast ? 0 : 14,
      }}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 7,
        }}
      >
        <text.H3>{item.code}</text.H3>
        <svg.CopySvg />
      </View>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <View
          style={{
            backgroundColor: resolveBadgeColor(item.discount),
            paddingHorizontal: 8,
            paddingVertical: 3,
            borderRadius: 5,
          }}
        >
          <Text
            style={{
              ...theme.fonts.DMSans_500Medium,
              color: theme.colors.backgroundPrimary,
              fontSize: 12,
            }}
          >
            {formatDiscountLabel(item.discount)}
          </Text>
        </View>

        <Text
          style={{
            ...theme.fonts.DMSans_400Regular,
            fontSize: 12,
            color: theme.colors.textMuted,
            textAlign: 'right',
          }}
        >
          {item.expires_at ?? 'No expiry date'}
        </Text>
      </View>
    </TouchableOpacity>
  );
};

export default PromocodeItem;
